export default __webpack_public_path__ + "static/media/Resume2.6a422a88.png";